// Add accessibility to nav
function patchOwlNavAria($carousel) {
    const $prev = $carousel.find(".owl-prev");
    const $next = $carousel.find(".owl-next");

    $prev.attr({
        type: "button",
        "aria-label": "Previous slide",
        title: "Previous slide",
    });

    $next.attr({
        type: "button",
        "aria-label": "Next slide",
        title: "Next slide",
    });

    // Reflect disabled state accessibly
    [$prev, $next].forEach(function ($btn) {
        const disabled = $btn.hasClass("disabled");
        $btn.attr("aria-disabled", disabled ? "true" : "false");
        $btn.prop("disabled", disabled);
        if (disabled) {
            $btn.attr("tabindex", "-1");
        } else {
            $btn.removeAttr("tabindex");
        }
    });
}

// Initialize carousel
var owl = $(".card-carousel").owlCarousel({
    rewind: true,
    items: 1,
    navElement: "button",
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    responsiveClass: true,
    autoHeight: true,
    onInitialized: function (event) {
        patchOwlNavAria($(event.target));
    },
    onResized: function (event) {
        patchOwlNavAria($(event.target));
    },
    onRefreshed: function (event) {
        patchOwlNavAria($(event.target));
    },
    onChanged: function (event) {
        patchOwlNavAria($(event.target));
    },
    responsive: {
        0: {
            dots: true,
            nav: false,
            mouseDrag: true,
            touchDrag: true,
        },
        960: {
            dots: false,
            nav: true,
            navText: ["keyboard_arrow_left", "keyboard_arrow_right"],
            mouseDrag: false,
            touchDrag: false,
        },
    },
});
